import {isPlainObject} from "../../../../utils/type-check";

export default function getRuleError(rule, allValues, defaultError) {
    if (isPlainObject(rule)) {
        if ('function' === typeof rule.error) {
            if (allValues instanceof Array) {
                // allValues and extras
                return rule.error(allValues[0], allValues[1]);
            }

            return rule.error(allValues);
        }

        if ('string' === typeof rule.error) {
            return rule.error;
        }
    }

    return defaultError;
}
